import { useEnquireCta } from '~/modules/enquiry/hooks/use-page-ctas';

const CONTACT_LABEL = 'Contact';

interface ProfessionalContactTabButtonProps {
    /** The tab's styling, so it matches the links either sub-nav renders. */
    className: string;
}

/**
 * The Contact tab for a professional with no visible location: there is no
 * location page to link to, so the tab opens the enquiry modal instead. Mirrors
 * the legacy desktop header and mobile nav, which keep Contact in the bar for
 * these professionals.
 *
 * Renders nothing when the page's Enquire button is hidden for the current
 * user — the tab would have nowhere to go.
 */
export const ProfessionalContactTabButton = ({
    className,
}: ProfessionalContactTabButtonProps) => {
    const enquire = useEnquireCta({
        source: 'ProfessionalContactTab',
        fixedLabel: CONTACT_LABEL,
    });

    if (!enquire.visible) return null;

    return (
        <button
            type="button"
            className={className}
            onClick={() => enquire.open()}
        >
            {/* The tab's name stays put; a configured form's label titles
                the modal it opens. */}
            {CONTACT_LABEL}
        </button>
    );
};
